const CONSTANTS = {
  APP_ENV: import.meta.env.VITE_APP_ENV,
  API_BASE_URL: import.meta.env.VITE_STACK_API_BASE_URL,
  PUBLIC_SENTRY_DSN: import.meta.env.VITE_PUBLIC_SENTRY_DSN,
  ACCESS_TOKEN_STORAGE_KEY: 'accessToken',
  REFRESH_TOKEN_STORAGE_KEY: 'refreshToken',
  ACTIVE_ROLE_STORAGE_KEY: 'activeRole',
  RECAPTCHA_TOKEN_STORAGE_KEY: 'recaptchaToken',
  RECAPTCHA_V3_SITE_KEY: import.meta.env.VITE_RECAPTCHA_V3_SITE_KEY,
  SEGMENT_WRITE_KEY: import.meta.env.VITE_SEGMENT_WRITE_KEY,
  PARTNER_TYPE_PUBLISHER: 'PUBLISHER'
}

Object.freeze(CONSTANTS)

export default CONSTANTS
